"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
/**
 * 超链组件
 */
function Link(props) {
    var text = props.text, to = props.to, extendProps = props.extendProps;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    return (react_1.default.createElement("a", __assign({ href: to, target: "_blank", className: "".concat(classPrefix, "-coupon-link"), rel: "noreferrer" }, extendProps),
        text,
        ">"));
}
exports.default = Link;
//# sourceMappingURL=Link.js.map